import React from 'react';
import styled from 'styled-components';

const MpLogoStyled = styled(`img`)`
	width: 98px;
	height: 32px;
`;

export const DodoIsLogo: React.FC = () => <MpLogoStyled src='https://cdn.dodostatic.net/static/marketplace/logo3' />;
